import { Component, viewChild, effect, inject, NgZone, type ElementRef } from "@angular/core";
import { CdkVirtualScrollViewport, ScrollingModule } from "@angular/cdk/scrolling";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { WkDataTableHeader } from "@app/shared/components/data-table/header";
import { WkDataTable } from "@components/data-table/classes";
import { WkDataTableItem } from "@app/shared/components/data-table/item";

@Component({
    selector: "wk-data-table-virtual",
    templateUrl: "./data-table-virtual.component.html",
    styleUrls: ["./data-table-virtual.component.scss", "../data-table.scss"],
    imports: [JumpstartComponentsModule, ScrollingModule, WkDataTableHeader, WkDataTableItem],
    host: {
        class: "wk-data-table__virtual fancy-scrollbar-newUI",
    },
})
export class WkDataTableVirtual<TItem> extends WkDataTable<TItem> {
    private viewport = viewChild<CdkVirtualScrollViewport>("viewport");
    private header = viewChild<ElementRef<HTMLElement>>("header");
    private readonly ngZone = inject(NgZone);

    constructor() {
        super();

        effect((onCleanup) => {
            const viewport = this.viewport();
            const header = this.header()?.nativeElement;
            if (!viewport || !header) return;

            const vp = viewport.elementRef.nativeElement as HTMLElement;

            if (CSS.supports("timeline-scope", "--a")) {
                const updateMaxScroll = () => {
                    header.style.setProperty("--wk-dt-max-scroll", `${Math.max(0, vp.scrollWidth - vp.clientWidth)}px`);
                };
                updateMaxScroll();

                const ro = new ResizeObserver(updateMaxScroll);
                ro.observe(vp);
                if (vp.children[0]) ro.observe(vp.children[0]);
                onCleanup(() => ro.disconnect());
                return;
            }

            const sync = () => (header.scrollLeft = vp.scrollLeft);
            sync();

            this.ngZone.runOutsideAngular(() => vp.addEventListener("scroll", sync, { passive: true }));
            onCleanup(() => vp.removeEventListener("scroll", sync));
        });
    }
}
